module.exports = __webpack_public_path__ + "img/Shield-and-lock.818f01a8.png";